import { mainAxios } from "../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "./mainService";

export const editarCliente = async (clienteId, bodyData) => {
  try {
    const response = await mainAxios.put(
      `/v1/modificacionCliente/update/${clienteId}`,
      bodyData,
      getDefaultHeaders()
    );

    return response.data.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getClienteById = async (clienteId) => {
  try {
    const response = await mainAxios.get(
      `/v1/cliente/id/${clienteId}`,
      getDefaultHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getClientesByFiltros = async (filters) => {
  try {
    const response = await mainAxios.post(
      `/v1/clientes/filtro`,
      filters,
      getDefaultHeaders()
    );

    return response.data.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};